import module from 'nominas/nomina/module.js'
import template from './template.html'

/*const sumar = (obj, key, value) => {
  return obj[key] = +((obj[key] || 0) + value).toFixed(2)
}*/

export class NominasNominaColaboradoresResumenComponent {
  calculado
  data
  onOpen
  onClose

  $onChanges (changes) {
    if (changes.data && Array.isArray(this.data)) {
      let data = {
        importe: 0,
        comision_importe: 0,
        neto: 0,
        total_percepciones: 0,
        total_deducciones: 0,
        neto_a_pagar: 0,
        colaboradores: this.data.length,
        percepciones: {},
        deducciones: {},
      }

      this.data.forEach((colaborador) => {
        data.importe = +(data.importe + (colaborador.importe || 0)).toFixed(2)
        data.comision_importe = +(data.comision_importe + (colaborador.comision_importe || 0)).toFixed(2)
        data.neto = +(data.neto + (colaborador.neto || 0)).toFixed(2)
        data.total_percepciones = +(data.total_percepciones + (colaborador.total_percepciones || 0)).toFixed(2)
        data.total_deducciones = +(data.total_deducciones + (colaborador.total_deducciones || 0)).toFixed(2)
        data.neto_a_pagar = +(data.neto_a_pagar + (colaborador.neto_a_pagar || 0)).toFixed(2)
        // Object.values(colaborador.percepciones).forEach((value, key) => (sumar(data.percepciones, key, value.importe)))
        // Object.values(colaborador.deducciones).forEach((value, key) => (sumar(data.deducciones, key, value.importe)))
      })

      this.data = data
    } else if (changes.data) {
      this.data = null
    }
  }
}

module.component('nominasNominaColaboradoresResumen', {
  controller: NominasNominaColaboradoresResumenComponent,
  template,
  bindings: {
    calculado: '<',
    data: '<',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/colaboradores/resumen/component.js